import { Space, Text } from "@/atoms"
import { RobotOutlined } from "@/icons"

import stylesRuleCard from "../RuleCard/RuleCard.module.scss"
import styles from "./RuleCardList.module.scss"

import type { TitleDrawerRuleProps } from "./RuleCardList.types"

export const TitleDrawerRule = (props: TitleDrawerRuleProps) => {
  const { record } = props
  const isScope = record.type === "scope"
  const isEnvironment = isScope && record.subtype === "environment"
  const isAgent = record.type === "agent"

  return (
    <Space
      className={styles.titleSpace}
      separator={<span className={stylesRuleCard.separator}>|</span>}
    >
      {isScope && !isEnvironment && (
        <Text type="secondary">{`Scope: ${record.name}`}</Text>
      )}
      {isEnvironment && (
        <Text type="secondary">{`Environment: ${record.name}`}</Text>
      )}
      {isAgent && (
        <Text type="secondary">
          <RobotOutlined />
          {` ${record.name}`}
        </Text>
      )}
      <Text type="secondary">{`Policy: ${record.policyName}`}</Text>
      {isAgent && (
        <Text type="secondary">Policy inherited from All agents</Text>
      )}
      {!isAgent && !!record.agents?.length && (
        <Text type="secondary">{`Followed by ${record.agents.length} agents`}</Text>
      )}
    </Space>
  )
}
